import styled from 'styled-components';

export const CMSOptionsContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: right;
    align-items: center;
    width: 95%;
    margin-top: 20px;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 2rem;
`;

export const Slug = styled.p`
  font-size: 1rem;
  color: #555;
  margin-bottom: 1rem;
`;